jQuery(document).ready(($) => {
    // Nav Toggle

    let isTouchEnabledDevice = () =>
        window.matchMedia("(pointer: coarse)").matches ? true : false;

    let breakpoints = {
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        xl2: 1536,
        xl3: 1920,
    };

    // Enable Mixed Scroll Slider
    let mixedScrollLock = true;

    // Navigation Toggle
    $(".js-nav-toggle").on("click", function (e) {
        $(this).toggleClass("is-active");
        $(".js-overlay-navigation").toggleClass("is-active");
        $("body").toggleClass("is-locked");
    });

    $(".menu-item-has-children a").on("click", function (e) {
        e.preventDefault;
        $(this).parent("li").toggleClass("is-open");
        $(this).parent("li").find(".sub-menu").toggleClass("is-open");
    });

    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            $(".js-nav-toggle").removeClass("is-active");
            $(".js-overlay-navigation").removeClass("is-active");
            $("body").removeClass("is-locked");
        }
    });

    // Filter Form
    $(".js-filters-form select").on("select2:select", function () {
        $("body").addClass("is-loading");

        const postType = $(".js-filter-post-type").val();
        const actionName =
            postType === "case_studies"
                ? "filter_case-studies"
                : "filter_posts";

        const dataToSend =
            $(".js-filters-form select").serialize() + "&action=" + actionName;

        $.ajax({
            url: ajaxObject.ajaxUrl,
            type: "POST",
            data: dataToSend,
            success: function (response) {
                $(".js-ajax-container").html(response);
                $("body").removeClass("is-loading");
                $("html, body").animate(
                    {
                        scrollTop: $(".js-filters-scroll-top").offset().top,
                    },
                    500
                );
                ScrollTrigger.refresh();
            },
            error: function (xhr, status, error) {
                $("body").removeClass("is-loading");
                ScrollTrigger.refresh();
            },
        });
    });

    // Contact Us Form
    document.addEventListener(
        "wpcf7mailsent",
        function (event) {
            if (event.detail.status === "mail_sent") {
                document
                    .querySelector(".js-form-overlay.js-form-overlay-ty")
                    .classList.add("is-active");
            }
        },
        false
    );

    var closeButton = document.querySelector(".js-close-form-overlay");
    if (closeButton) {
        closeButton.addEventListener("click", function () {
            var formOverlay = $(".js-form-overlay");
            if (formOverlay) {
                $(formOverlay).removeClass("is-active");
                $("body").removeClass("is-locked");
            }
        });
    }

    $(".js-overlay-form-button").click(function (e) {
        var href = $(this).attr("href");
        if (href.includes("contact") && $(window).width() > 1024) {
            e.preventDefault();
            $(".js-form-overlay-form").addClass("is-active");
            $("body").addClass("is-locked");
        }
    });
    $(".js-overlay-form-button-close").click(function (e) {
        e.preventDefault();
        $(".js-form-overlay-form").removeClass("is-active");
        $("body").removeClass("is-locked");
    });

    function isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    // Animations Etc
    gsap.registerPlugin(ScrollTrigger);

    if (!isSafari()) {
        // Homepage Hero Animation
        gsap.registerPlugin(MotionPathPlugin);

        const homepageHeroBannerPath = document.querySelector("#path");
        if (homepageHeroBannerPath) {
            const pathLength = homepageHeroBannerPath.getTotalLength();

            gsap.set("#path", {
                strokeDasharray: pathLength,
                strokeDashoffset: -pathLength,
            });

            let $durationTime = 8; // Duration in seconds

            gsap.to("#path", {
                duration: $durationTime,
                ease: "power1.inOut",
                strokeDashoffset: 0,
            });

            gsap.to("#arrow", {
                duration: $durationTime,
                ease: "power1.inOut",
                motionPath: {
                    path: "#path",
                    align: "#path",
                    autoRotate: true,
                    alignOrigin: [0.5, 0.5],
                    start: 1,
                    end: 0,
                },
            });

            // Define a default delay value as a fallback
            const defaultDelay = 2; // Default delay in seconds

            // Select all elements with the .js-svg-fade-in class
            const elements = document.querySelectorAll(".js-svg-fade-in");

            // Loop through each element
            elements.forEach((element) => {
                // Read the delay value from the data-delay attribute, or use the default delay
                let fadeInDelay =
                    parseFloat(element.getAttribute("data-delay")) ||
                    defaultDelay;

                // Apply the GSAP animation with the specified delay
                gsap.set(element, {
                    delay: fadeInDelay,
                    onComplete: function () {
                        element.classList.add("is-active");
                    },
                });
            });
        }
    } else {
        $(".c-home-hero__animated-svg").addClass("hidden");
    }

    gsap.utils.toArray(".js-in-viewport").forEach((element, i) => {
        gsap.fromTo(
            element,
            { autoAlpha: 0, y: 20 },
            {
                duration: 0.5,
                ease: "linear", // Set easing to linear
                autoAlpha: 1,
                y: 0,
                scrollTrigger: {
                    trigger: element,
                    start: "top 98%",
                    markers: false,
                },
            }
        );
    });
    if (window.innerWidth > 768) {
        gsap.utils
            .toArray(".js-in-viewport-news")
            .forEach(function (element, index) {
                delay = index * 0.3;
                gsap.fromTo(
                    element,
                    {
                        y: 40,
                        autoAlpha: 0,
                    },
                    {
                        delay: delay, // Adjusted for visibility
                        duration: 0.5,
                        y: 0,
                        autoAlpha: 1,
                        ease: "none",
                        scrollTrigger: {
                            trigger: element,
                            start: "top 90%",
                            end: "bottom 90%",
                            toggleActions: "play none none reverse",
                            markers: false,
                            once: true,
                            //scrub: 1,
                        },
                    }
                );
            });
    }
    // Draw In Arrows
    function drawInArrows() {
        const svgs = document.querySelectorAll(".js-svg-draw-arrow");
        svgs.forEach((svg) => {
            let drawDuration = svg.classList.contains("js-svg-draw-arrow--slow")
                ? 1
                : 0.5;
            let fadeDuration = 0.1;
            let delayBeforeFade = 0;
            let visibilityDelay = svg.classList.contains(
                "js-svg-draw-arrow--slow"
            )
                ? 0.2
                : 0.2;
            const paths = svg.querySelectorAll("path");

            if (paths.length > 0) {
                const firstPath = paths[0];
                const length = firstPath.getTotalLength();
                gsap.set(firstPath, {
                    strokeDasharray: length,
                    strokeDashoffset: length,
                });

                // Delay visibility
                gsap.to(firstPath, {
                    visibility: "visible",
                    delay: visibilityDelay,
                });

                ScrollTrigger.create({
                    trigger: svg,
                    start: "top 75%",
                    once: true,
                    onEnter: () => {
                        gsap.fromTo(
                            firstPath,
                            { strokeDashoffset: length },
                            {
                                strokeDashoffset: 0,
                                duration: drawDuration,
                                ease: "none",
                                onComplete: () => {
                                    if (paths.length > 1) {
                                        const secondPath = paths[1];
                                        gsap.delayedCall(
                                            delayBeforeFade,
                                            () => {
                                                gsap.fromTo(
                                                    secondPath,
                                                    { opacity: 0 },
                                                    {
                                                        opacity: 1,
                                                        duration: fadeDuration,
                                                        ease: "none",
                                                    }
                                                );
                                            }
                                        );
                                    }
                                },
                            }
                        );
                    },
                    markers: false,
                });
            }
        });
    }
    function drawInHowWeDoit() {
        const svgs = document.querySelectorAll(".js-svg-how-we-do-it");
        svgs.forEach((svg) => {
            let drawDuration = 4;
            let fadeDuration = 0.1;
            let delayBeforeFade = 0;
            let visibilityDelay = 0.1;
            const paths = svg.querySelectorAll("path");

            if (paths.length > 0) {
                const firstPath = paths[0];
                const length = firstPath.getTotalLength();
                gsap.set(firstPath, {
                    strokeDasharray: length,
                    strokeDashoffset: length,
                });

                // Delay visibility
                gsap.to(firstPath, {
                    visibility: "visible",
                    delay: visibilityDelay,
                });

                ScrollTrigger.create({
                    trigger: svg,
                    start: "top 75%",
                    once: true,
                    onEnter: () => {
                        gsap.fromTo(
                            firstPath,
                            { strokeDashoffset: length },
                            {
                                strokeDashoffset: 0,
                                duration: drawDuration,
                                ease: "none",
                                onComplete: () => {
                                    if (paths.length > 1) {
                                        const secondPath = paths[1];
                                        gsap.delayedCall(
                                            delayBeforeFade,
                                            () => {
                                                gsap.fromTo(
                                                    secondPath,
                                                    { opacity: 0 },
                                                    {
                                                        opacity: 1,
                                                        duration: fadeDuration,
                                                        ease: "none",
                                                    }
                                                );
                                            }
                                        );
                                    }
                                },
                            }
                        );
                    },
                    markers: false,
                });
            }
        });
    }

    document
        .querySelectorAll(".js-svg-draw-container")
        .forEach((container, containerIndex) => {
            let delay = 0;
            let duration = 1;
            let extraDelay = 1; // Extra delay before starting each new animation
            const triggerStart = "top 75%"; // Example trigger point
            gsap.utils
                .toArray(container.querySelectorAll(".js-svg-draw"))
                .forEach((svg, index) => {
                    const path = svg.querySelector("path");
                    const length = path.getTotalLength();
                    const arrow = svg.querySelector(".js-svg-arrow");
                    gsap.set(path, {
                        strokeDasharray: length,
                        strokeDashoffset: length,
                        visibility: "visible",
                    });

                    // Adjust the delay for the arrow animation specifically
                    let arrowAnimationDelay = index === 0 ? 0 : delay; // No extra delay for the first arrow

                    const animation = gsap.fromTo(
                        path,
                        { strokeDashoffset: length },
                        {
                            strokeDashoffset: 0,
                            duration: duration,
                            ease: "none",
                            delay: delay,
                        }
                    );

                    ScrollTrigger.create({
                        animation: animation,
                        trigger: container,
                        start: triggerStart,
                        markers: false,
                        onEnter: () => {
                            if (arrow) {
                                gsap.set(arrow, { visibility: "visible" });
                                gsap.to(arrow, {
                                    duration: duration,
                                    ease: "none",
                                    motionPath: {
                                        path: path,
                                        align: path,
                                        autoRotate: true,
                                        alignOrigin: [0.5, 0.5],
                                    },
                                    delay: arrowAnimationDelay, // Apply adjusted delay here
                                    onStart: () =>
                                        arrow.classList.add("is-animating"),
                                    onComplete: () => {
                                        arrow.classList.remove("is-animating");
                                        arrow.classList.add("is-finished");
                                    },
                                });
                            }
                        },
                    });

                    // Only apply extraDelay to delay after the first SVG/arrow set
                    if (index > 0) {
                        delay += extraDelay;
                    }
                    delay += duration; // Increment delay for the next SVG
                });
        });

    gsap.utils.toArray(".js-svg-draw-single").forEach((svg) => {
        const path = svg.querySelector("path");
        const length = path.getTotalLength();
        // Assume arrow is correctly placed within your SVG for masking
        const arrow = svg.querySelector(".js-dashed-arrow"); // Adjust selector as needed

        // Initial path setup
        gsap.set(path, {
            strokeDasharray: `${length} ${length}`,
            strokeDashoffset: length,
        });

        // Animation for the path
        const pathTween = gsap.to(path, {
            strokeDashoffset: 0,
            ease: "none",
            paused: true,
        });

        // Assuming the arrow needs to be animated along the path
        const arrowTween = gsap.to(arrow, {
            motionPath: {
                path: path,
                align: path,
                alignOrigin: [0.5, 0.5],
                autoRotate: true,
            },
            ease: "none",
            paused: true, // Start paused and control via ScrollTrigger
            onStart: () => arrow.classList.add("is-animating"),
            onComplete: () => {
                arrow.classList.remove("is-animating");
                arrow.classList.add("is-finished");
            },
        });

        ScrollTrigger.create({
            trigger: svg,
            start: "top 85%",
            end: "50% top",
            scrub: true,
            markers: false,
            onUpdate: (self) => {
                const progress = self.progress;
                pathTween.progress(progress);
                arrowTween.progress(progress);
                path.style.visibility = progress ? "visible" : "hidden";
                if (arrow)
                    arrow.style.visibility = progress ? "visible" : "hidden"; // Control arrow visibility similarly
            },
        });
    });

    // Initialize the animations when ScrollTrigger is ready
    drawInHowWeDoit();
    drawInArrows();

    // Slider Scroll Jack
    function sliderScrollJack(
        element,
        slider,
        resetOnEnterBack,
        startingEdgeDisable = true,
        customStart = "top 50%",
        customEnd = "bottom center",
        scrollBackOnEnter = false,
        delayOnEnd = false
    ) {
        const st = ScrollTrigger.create({
            trigger: element,
            start: customStart,
            end: customEnd,
            //markers: true,
            onEnter: () => {
                //slider.enable();
                if (slider.isBeginning && slider.isEnd) return;
                const triggerEnd = st.end;
                const scrollPos =
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;

                if (scrollPos > triggerEnd) {
                    return;
                }
                let delayTime = 0;
                if (delayOnEnd) {
                    delayTime = 1000;
                }
                slider.enable();
                if (scrollBackOnEnter) {
                    window.scrollTo({
                        top: element.offsetTop,
                        behavior: "smooth",
                    });
                }
                slider.on("toEdge", () => {
                    if (slider.isBeginning) {
                        if (startingEdgeDisable) {
                            if ($(slider.el).hasClass("has-reached-end")) {
                                setTimeout(() => {
                                    slider.disable();
                                }, delayTime);
                            }
                        }
                    } else if (slider.isEnd) {
                        setTimeout(() => {
                            slider.disable();
                        }, delayTime);
                    }
                });

                slider.on("reachBeginning", () => {
                    if (startingEdgeDisable) {
                        slider.disable();
                    }
                });

                slider.on("reachEnd", () => {
                    setTimeout(() => {
                        slider.disable();
                    }, delayTime);
                });
            },
            onEnterBack: () => {
                if (slider.isBeginning && slider.isEnd) return;
                if (slider.isBeginning) {
                    if (scrollBackOnEnter) {
                        window.scrollTo({
                            top: element.offsetTop,
                            behavior: "smooth",
                        });
                        setTimeout(() => {
                            slider.enable();
                        }, 500);
                    }
                }
                if (slider.isEnd) {
                    if (scrollBackOnEnter) {
                        window.scrollTo({
                            top: element.offsetTop,
                            behavior: "smooth",
                        });
                        setTimeout(() => {
                            slider.enable();
                        }, 300);
                    } else if (resetOnEnterBack) {
                        slider.enable();
                        slider.slideTo(0);
                        slider.disable();
                        // console.log("reset");
                    } else {
                        slider.enable();
                    }
                }

                let delayTime = 0;
                if (delayOnEnd) {
                    delayTime = 0;
                }

                slider.on("toEdge", () => {
                    if (slider.isBeginning) {
                        if (startingEdgeDisable) {
                            if ($(slider.el).hasClass("has-reached-end")) {
                                slider.disable();
                            }
                        }
                    } else if (slider.isEnd) {
                        setTimeout(() => {
                            slider.disable();
                        }, delayTime);
                    }
                });
            },
            onEnd: () => {
                setTimeout(() => {
                    slider.disable();
                }, delayTime);
            },
        });
    }

    let sliderElement = document.querySelectorAll(".js-persons-slider");

    sliderElement.forEach((element) => {
        let breakpoint = window.matchMedia(`(min-width: ${breakpoints.lg}px)`);
        let slider;

        let setupSlider = () => {
            if (slider !== undefined) slider.destroy(true, true);

            // Just for mobile and tablets
            if (breakpoint.matches === false || isTouchEnabledDevice()) {
                slider = new Swiper(element, {
                    slidesPerView: 1,
                    loop: false,
                    allowTouchMove: true,
                    freeMode: false,
                    spaceBetween: 14,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 2,
                        },
                        1536: {
                            slidesPerView: 4,
                        },
                    },
                });
            } else {
                slider = new Swiper(element, {
                    slidesPerView: "auto",
                    loop: false,
                    allowTouchMove: true,
                    passiveListeners: false,
                    observer: true,
                    freeMode: true,
                    mousewheel: {
                        eventsTarget: "#main-root",
                        sensitivity: 0.75,
                    },
                    watchSlidesVisibility: true,
                    watchOverflow: true,
                });

                slider.disable();
                slider.on("progress", () => {
                    if (slider.isEnd) {
                        slider.disable();
                    }
                });

                sliderScrollJack(element, slider, true);
            }
        };

        breakpoint.addEventListener("change", setupSlider);
        setupSlider();
    });

    // Stats Scroller Scroll Lock
    let statsScrollSlider = document.querySelectorAll(".js-stats-scroll");
    let statsScrollCount = $(statsScrollSlider).find(
        ".c-stats-scroll__slide"
    ).length;

    statsScrollSlider.forEach((element) => {
        let breakpoint = window.matchMedia(`(min-width: ${breakpoints.lg}px)`);
        let slider;

        let setupSlider = () => {
            if (slider !== undefined) slider.destroy(true, true);

            // Just for mobile and tablets
            if (breakpoint.matches === false || isTouchEnabledDevice()) {
                slider = new Swiper(element, {
                    slidesPerView: 1,
                    loop: false,
                    allowTouchMove: true,
                    freeMode: false,
                    spaceBetween: 14,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 2,
                        },
                        1536: {
                            slidesPerView: 4,
                        },
                    },
                });
            } else {
                if (statsScrollCount > 3) {
                    slider = new Swiper(element, {
                        slidesPerView: "auto",
                        loop: false,
                        allowTouchMove: true,
                        passiveListeners: false,
                        observer: true,
                        freeMode: true,
                        mousewheel: {
                            eventsTarget: "#main-root",
                            sensitivity: 0.75,
                        },
                        watchSlidesVisibility: true,
                        watchOverflow: true,
                        spaceBetween: 20,
                    });

                    slider.disable();

                    sliderScrollJack(element, slider, true);
                } else {
                    $(statsScrollSlider).addClass("is-inactive");
                }
            }
        };

        breakpoint.addEventListener("change", setupSlider);
        setupSlider();
    });

    // Listen for scroll events to update the flag
    let hasPageBeenScrolled = false;
    window.addEventListener("scroll", () => {
        hasPageBeenScrolled = true;
    });

    // Homepage Testimonials Slider Scroll Lock

    let homepageTestimonialsSliderElement = document.querySelectorAll(
        ".js-testimonials-home"
    );

    homepageTestimonialsSliderElement.forEach((element) => {
        let breakpoint = window.matchMedia(`(min-width: ${breakpoints.lg}px)`);
        let slider;

        let setupSlider = () => {
            if (slider !== undefined) slider.destroy(true, true);

            // Just for mobile and tablets
            if (breakpoint.matches === false || isTouchEnabledDevice()) {
                slider = new Swiper(element, {
                    slidesPerView: 1,
                    loop: true,
                    allowTouchMove: true,
                    passiveListeners: false,
                    observer: true,
                    watchSlidesVisibility: true,
                    watchOverflow: true,
                    speed: 1000,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 1,
                            pagination: false,
                            direction: "vertical",
                        },
                        1536: {
                            slidesPerView: 1,
                            pagination: false,
                            direction: "vertical",
                        },
                    },
                });
                slider.on("slideChange", function () {
                    var totalSlides = this.slides.length;
                    var currentIndex = this.realIndex + 1; // because index starts at 0
                    $(".js-slider-count")
                        .text(currentIndex + "/" + totalSlides)
                        .attr("class", function (i, c) {
                            return c.replace(/\bis-slide-\d+/g, ""); // Remove previous class
                        })
                        .addClass("is-slide-" + (currentIndex - 1)); // Add new class based on current index
                });
                $(".js-slider-count").on("click", function () {
                    if (slider.isEnd) {
                        slider.enable();
                        slider.slideTo(0);
                    } else {
                        slider.enable();
                        slider.slideNext();
                    }
                });
            } else {
                slider = new Swiper(element, {
                    direction: "vertical",
                    loop: false,
                    allowTouchMove: true,
                    passiveListeners: false,
                    observer: true,
                    freeMode: true,
                    mousewheel: {
                        eventsTarget: "#main-root",
                        sensitivity: 0.5,
                    },
                    watchSlidesVisibility: true,
                    watchOverflow: true,
                    speed: 1000,
                });
                slider.on("slideChange", function () {
                    var totalSlides = this.slides.length;
                    var currentIndex = this.realIndex + 1; // because index starts at 0
                    $(".js-slider-count")
                        .text(currentIndex + "/" + totalSlides)
                        .attr("class", function (i, c) {
                            return c.replace(/\bis-slide-\d+/g, ""); // Remove previous class
                        })
                        .addClass("is-slide-" + (currentIndex - 1)); // Add new class based on current index
                });
                $(".js-slider-count").on("click", function () {
                    if (slider.isEnd) {
                        slider.enable();
                        slider.slideTo(0);
                    } else {
                        slider.enable();
                        slider.slideNext();
                    }
                });
                slider.disable();

                ScrollTrigger.create({
                    trigger: element,
                    start: "center center+=60", // Homepage Testimonials
                    end: "center center",
                    //markers: true,
                    onEnter: () => {
                        if (slider.isBeginning && slider.isEnd) return;
                        if (hasPageBeenScrolled) {
                            $("body").addClass("is-locked");
                            slider.enable();
                            setTimeout(() => {
                                $("body").removeClass("is-locked");
                            }, 1500);
                        }

                        const disableSlider = () => {
                            slider.disable();
                        };
                        // Consolidate duplicated listeners
                        slider.on("reachEnd", disableSlider);
                        slider.on("reachBeginning", disableSlider);
                    },
                    onEnterBack: () => {
                        if (slider.isBeginning && slider.isEnd) return;

                        // document.body.classList.add('overflow-hidden');
                        slider.enable();
                        slider.slideTo(0);
                        slider.disable();
                    },
                    onEnd: () => {
                        slider.disable();
                    },
                });
                ScrollTrigger.refresh();
            }
        };

        breakpoint.addEventListener("change", setupSlider);
        setupSlider();
    });
    let TestimonialsSliderElement =
        document.querySelectorAll(".js-testimonials");

    // Testimonials Slider
    TestimonialsSliderElement.forEach((element) => {
        let breakpoint = window.matchMedia(`(min-width: ${breakpoints.lg}px)`);
        let slider;

        let setupSlider = () => {
            if (slider !== undefined) slider.destroy(true, true);

            // Just for mobile and tablets
            if (breakpoint.matches === false || isTouchEnabledDevice()) {
                slider = new Swiper(element, {
                    direction: "vertical",
                    loop: true,
                    allowTouchMove: false,
                    passiveListeners: false,
                    observer: true,
                    watchSlidesVisibility: true,
                    watchOverflow: true,
                    speed: 1000,
                });
                slider.on("slideChange", function () {
                    var totalSlides = this.slides.length;
                    var currentIndex = this.realIndex + 1; // because index starts at 0
                    $(".js-slider-count")
                        .text(currentIndex + "/" + totalSlides)
                        .attr("class", function (i, c) {
                            return c.replace(/\bis-slide-\d+/g, ""); // Remove previous class
                        })
                        .addClass("is-slide-" + (currentIndex - 1)); // Add new class based on current index
                });
                $(".js-slider-count").on("click", function () {
                    if (slider.isEnd) {
                        slider.enable();
                        slider.slideTo(0);
                    } else {
                        slider.enable();
                        slider.slideNext();
                    }
                });
            } else {
                slider = new Swiper(element, {
                    direction: "vertical",
                    loop: false,
                    allowTouchMove: true,
                    passiveListeners: false,
                    observer: true,
                    freeMode: true,
                    mousewheel: {
                        eventsTarget: "#main-root",
                        sensitivity: 0.5,
                    },
                    watchSlidesVisibility: true,
                    watchOverflow: true,
                    speed: 1000,
                });
                slider.on("slideChange", function () {
                    var totalSlides = this.slides.length;
                    var currentIndex = this.realIndex + 1; // because index starts at 0
                    $(".js-slider-count")
                        .text(currentIndex + "/" + totalSlides)
                        .attr("class", function (i, c) {
                            return c.replace(/\bis-slide-\d+/g, ""); // Remove previous class
                        })
                        .addClass("is-slide-" + (currentIndex - 1)); // Add new class based on current index
                });
                $(".js-slider-count").on("click", function () {
                    if (slider.isEnd) {
                        slider.enable();
                        slider.slideTo(0);
                    } else {
                        slider.enable();
                        slider.slideNext();
                    }
                });
                slider.disable();

                ScrollTrigger.create({
                    trigger: element,
                    start: "center center+=0",
                    end: "center center",
                    markers: false,
                    onEnter: () => {
                        if (slider.isBeginning && slider.isEnd) return;
                        if (hasPageBeenScrolled) {
                            $("body").addClass("is-locked");
                            slider.enable();
                            setTimeout(() => {
                                $("body").removeClass("is-locked");
                            }, 1500);
                        }

                        const disableSlider = () => {
                            slider.disable();
                        };
                        // Consolidate duplicated listeners
                        slider.on("reachEnd", disableSlider);
                        slider.on("reachBeginning", disableSlider);
                    },
                    onEnterBack: () => {
                        if (slider.isBeginning && slider.isEnd) return;

                        // document.body.classList.add('overflow-hidden');
                        slider.enable();
                        slider.slideTo(0);
                        slider.disable();
                    },
                    onEnd: () => {
                        slider.disable();
                    },
                });
                ScrollTrigger.refresh();
            }
        };

        breakpoint.addEventListener("change", setupSlider);
        setupSlider();
    });

    // About Us Slider Scroll Lock
    let aboutUsSliderElement = document.querySelectorAll(".js-about-us-scroll");

    aboutUsSliderElement.forEach((element) => {
        let breakpoint = window.matchMedia(`(min-width: ${breakpoints.lg}px)`);
        let slider;

        let setupSlider = () => {
            if (slider !== undefined) slider.destroy(true, true);

            // Just for mobile and tablets
            if (breakpoint.matches === false || isTouchEnabledDevice()) {
            } else {
                slider = new Swiper(element, {
                    slidesPerView: "auto",
                    loop: false,
                    allowTouchMove: true,
                    passiveListeners: false,
                    observer: true,
                    freeMode: true,
                    freeModeMomentum: true,
                    freeModeMomentumRatio: 1.5,
                    freeModeMomentumVelocityRatio: 1,
                    mousewheel: {
                        eventsTarget: "#main-root",
                        sensitivity: 0.72,
                    },
                    watchSlidesVisibility: true,
                    watchOverflow: true,
                });
                slider.on("slideChange", function () {
                    $(".js-about-us-bg").removeClass("is-active");
                    $(".js-about-us-bg-" + (this.realIndex + 1)).addClass(
                        "is-active"
                    );
                });
                slider.disable();
                sliderScrollJack(
                    element,
                    slider,
                    (resetOnEnterBack = false),
                    (startingEdgeDisable = false),
                    "top center",
                    "bottom center",
                    (scrollBackOnEnter = true),
                    (delayOnEnd = true)
                );
            }
        };

        breakpoint.addEventListener("change", setupSlider);
        setupSlider();
    });

    // Mixed Slider Scroll Lock
    if (mixedScrollLock) {
        let mixedSliderElement = document.querySelectorAll(
            ".js-mixed-horizontal-scroll"
        );

        mixedSliderElement.forEach((element) => {
            let breakpoint = window.matchMedia(
                `(min-width: ${breakpoints.lg}px)`
            );
            let slider;

            let setupSlider = () => {
                if (slider !== undefined) slider.destroy(true, true);

                // Just for mobile and tablets
                if (breakpoint.matches === false || isTouchEnabledDevice()) {
                } else {
                    slider = new Swiper(element, {
                        slidesPerView: "auto",
                        loop: false,
                        allowTouchMove: true,
                        passiveListeners: false,
                        observer: true,
                        freeMode: true,
                        freeModeMomentum: true,
                        freeModeMomentumRatio: 1.5,
                        freeModeMomentumVelocityRatio: 1,
                        mousewheel: {
                            eventsTarget: "#main-root",
                            sensitivity: 0.72,
                        },
                        watchSlidesVisibility: true,
                        watchOverflow: true,
                    });
                    slider.disable();

                    ScrollTrigger.create({
                        trigger: element,
                        start: "center center",
                        end: "center center",
                        //markers: true,
                        onEnter: () => {
                            if (slider.isBeginning && slider.isEnd) return;
                            if (hasPageBeenScrolled) {
                                $("body").addClass("is-locked");
                                slider.enable();
                                setTimeout(() => {
                                    $("body").removeClass("is-locked");
                                }, 1500);
                            }

                            const disableSlider = () => {
                                if (slider.isBeginning) {
                                    mixedDelayTime = 0;
                                } else {
                                    mixedDelayTime = 1000;
                                }
                                slider.disable();
                                $("body").addClass("is-locked");
                                setTimeout(function () {
                                    $("body").removeClass("is-locked");
                                }, mixedDelayTime);
                            };
                            // Consolidate duplicated listeners
                            slider.on("reachEnd", disableSlider);
                            slider.on("reachBeginning", disableSlider);
                        },
                        onUpdate: (self) => {
                            if (self.progress === 1) {
                                // $("body").addClass("is-locked");
                                // setTimeout(function () {
                                //     $("body").removeClass("is-locked");
                                // }, 500);
                            }
                        },
                        onEnterBack: () => {
                            if (slider.isBeginning && slider.isEnd) return;

                            // document.body.classList.add('overflow-hidden');
                            slider.enable();
                            slider.slideTo(0);
                            slider.disable();
                        },
                        onEnd: () => {
                            slider.disable();
                        },
                    });
                    ScrollTrigger.refresh();
                }
            };

            breakpoint.addEventListener("change", setupSlider);
            setupSlider();
        });
    }

    //Sticky Homepage
    //if ($(window).width() > 30) {
    var supportsSticky = CSS.supports && CSS.supports("position", "sticky");
    function applyStickies() {
        if (!supportsSticky) return;

        var stickies = [].slice.call(
            document.querySelectorAll(".js-sticky-card-alt")
        );
        var anyStuck = false;

        stickies.forEach(function (sticky, index) {
            if (sticky.dataset.initialTop === undefined) {
                // Store initial top position of the element plus 50px delay
                sticky.dataset.initialTop =
                    sticky.getBoundingClientRect().top + window.scrollY + 50;
            }
            var isStuck = applyStickyClass(sticky, index);
            if (isStuck) anyStuck = true;
        });

        if (!anyStuck) {
            $(".js-card-button").removeClass("is-active");
            $(".js-card-button-0").addClass("is-active");
        }
    }

    function applyStickyClass(sticky, index) {
        var stickyInitialTop = parseFloat(sticky.dataset.initialTop);
        var isStuck =
            window.scrollY >=
            stickyInitialTop -
                parseInt(getComputedStyle(sticky).top.replace("px", ""));
        sticky.classList.toggle("js-is-sticky", isStuck);
        if (isStuck) {
            $(".js-card-button").removeClass("is-active");
            $(`.js-card-button-${index + 1}`).addClass("is-active");
        }
        return isStuck;
    }

    var scheduled = false;
    window.addEventListener("scroll", function () {
        if (!scheduled) {
            requestAnimationFrame(function () {
                applyStickies();
                scheduled = false;
            });
            scheduled = true;
        }
    });

    applyStickies();
    //}

    // Homepage Partners Slider
    const partnersSwiper = new Swiper(".js-partners-slider", {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
            900: {
                slidesPerView: 4,
                spaceBetween: 100,
            },
        },
    });

    // Select2
    (function ($) {
        var Defaults = $.fn.select2.amd.require("select2/defaults");

        $.extend(Defaults.defaults, {
            dropdownPosition: "auto",
        });

        var AttachBody = $.fn.select2.amd.require(
            "select2/dropdown/attachBody"
        );

        var _positionDropdown = AttachBody.prototype._positionDropdown;

        AttachBody.prototype._positionDropdown = function () {
            var $window = $(window);

            var isCurrentlyAbove = this.$dropdown.hasClass(
                "select2-dropdown--above"
            );
            var isCurrentlyBelow = this.$dropdown.hasClass(
                "select2-dropdown--below"
            );

            var newDirection = null;

            var offset = this.$container.offset();

            offset.bottom = offset.top + this.$container.outerHeight(false);

            var container = {
                height: this.$container.outerHeight(false),
            };

            container.top = offset.top;
            container.bottom = offset.top + container.height;

            var dropdown = {
                height: this.$dropdown.outerHeight(false),
            };

            var viewport = {
                top: $window.scrollTop(),
                bottom: $window.scrollTop() + $window.height(),
            };

            var enoughRoomAbove = viewport.top < offset.top - dropdown.height;
            var enoughRoomBelow =
                viewport.bottom > offset.bottom + dropdown.height;

            var css = {
                left: offset.left,
                top: container.bottom,
            };

            // Determine what the parent element is to use for calciulating the offset
            var $offsetParent = this.$dropdownParent;

            // For statically positoned elements, we need to get the element
            // that is determining the offset
            if ($offsetParent.css("position") === "static") {
                $offsetParent = $offsetParent.offsetParent();
            }

            var parentOffset = $offsetParent.offset();

            css.top -= parentOffset.top;
            css.left -= parentOffset.left;

            var dropdownPositionOption = this.options.get("dropdownPosition");

            if (
                dropdownPositionOption === "above" ||
                dropdownPositionOption === "below"
            ) {
                newDirection = dropdownPositionOption;
            } else {
                if (!isCurrentlyAbove && !isCurrentlyBelow) {
                    newDirection = "below";
                }

                if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
                    newDirection = "above";
                } else if (
                    !enoughRoomAbove &&
                    enoughRoomBelow &&
                    isCurrentlyAbove
                ) {
                    newDirection = "below";
                }
            }

            if (
                newDirection == "above" ||
                (isCurrentlyAbove && newDirection !== "below")
            ) {
                css.top = container.top - parentOffset.top - dropdown.height;
            }

            if (newDirection != null) {
                this.$dropdown
                    .removeClass(
                        "select2-dropdown--below select2-dropdown--above"
                    )
                    .addClass("select2-dropdown--" + newDirection);
                this.$container
                    .removeClass(
                        "select2-container--below select2-container--above"
                    )
                    .addClass("select2-container--" + newDirection);
            }

            this.$dropdownContainer.css(css);
        };
    })(window.jQuery);
    $(".js-select2").select2({
        minimumResultsForSearch: -1,
        dropdownPosition: "below",
    });

    document.querySelectorAll(".js-card-button").forEach((anchor) => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault();

            document.querySelectorAll(".js-card-button").forEach((el) => {
                el.classList.remove("is-active");
            });

            //this.classList.add("is-active");

            const scrollTarget = document.querySelector(
                this.getAttribute("href")
            );
            $(".js-sticky-card-alt").removeClass("tablet:sticky");
            let topOffset = 175;
            if (window.innerWidth > 760) {
                topOffset = 85;
            }
            const elementPosition = scrollTarget.getBoundingClientRect().top;
            const offsetPosition =
                elementPosition + window.pageYOffset - topOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
            $(".js-sticky-card-alt").addClass("tablet:sticky");
        });
    });

    // SVG  Moving Arrows
    if (!isTouchEnabledDevice() && window.innerWidth > 1024) {
        const containers = document.querySelectorAll(
            ".js-moving-svg-container"
        );
        const svgLastAngles = new Map(); // Use a Map to store last angles

        containers.forEach((container) => {
            container.addEventListener("mousemove", function (event) {
                const svgs = container.querySelectorAll("svg");
                svgs.forEach((svg) => {
                    const svgRect = svg.getBoundingClientRect();
                    const svgX = svgRect.left + svgRect.width / 2;
                    const svgY = svgRect.top + svgRect.height / 2;
                    const distance = Math.sqrt(
                        Math.pow(event.clientX - svgX, 2) +
                            Math.pow(event.clientY - svgY, 2)
                    );

                    if (distance <= 100) {
                        const angle =
                            Math.atan2(
                                event.clientY - svgY,
                                event.clientX - svgX
                            ) *
                                (180 / Math.PI) +
                            180;
                        const lastAngle = svgLastAngles.get(svg);

                        // Update the rotation only if there's a significant change
                        if (
                            lastAngle === undefined ||
                            Math.abs(lastAngle - angle) > 5
                        ) {
                            // Adjust the threshold as needed
                            svg.style.transform = `rotate(${angle}deg)`;
                            svgLastAngles.set(svg, angle); // Update the last angle
                        }
                    }
                });
            });
        });
    }

    // How We Do It SVG/Lock Scroll
    // Utilize gsap.utils.toArray for potential NodeList operations and ensure elements are present
    const paths = gsap.utils.toArray(".js-how-we-do-it-svg path");
    const container = document.querySelector(".js-how-we-do-it");

    if (!isTouchEnabledDevice() && window.innerWidth > 1024) {
        if (container && paths.length > 0) {
            paths.forEach((path) => {
                const length = path.getTotalLength();
                gsap.set(path, {
                    strokeDasharray: length,
                    strokeDashoffset: length,
                });
            });

            let howWeDoItTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: "top top",
                    end: () => "+=" + container.offsetWidth,
                    scrub: 0.5,
                    pin: true,
                    markers: false,
                    onUpdate: (self) => {
                        if (self.progress === 1) {
                            $("body").addClass("is-locked");
                            setTimeout(function () {
                                $("body").removeClass("is-locked");
                            }, 500);
                        }
                        const arrowOpacity = self.progress === 1 ? 1 : 0;
                        gsap.to(".js-how-we-do-it-arrow-svg", {
                            opacity: arrowOpacity,
                            immediateRender: false,
                        });
                    },
                },
            });

            howWeDoItTimeline.to(container, {
                x: () => -(container.scrollWidth - window.innerWidth) + "px",
                ease: "none",
            });

            paths.forEach((path) => {
                const length = path.getTotalLength();
                howWeDoItTimeline.fromTo(
                    path,
                    { strokeDashoffset: length },
                    { strokeDashoffset: 0, ease: "none" },
                    0 // This aligns the animation with the start of the timeline
                );
            });
        }
    }

    // Form Focus Arrow
    var formContainer = document.querySelector(".js-contact-form");
    if (formContainer) {
        var formInputs = formContainer.querySelectorAll(
            "input, textarea, select"
        );
        if (formInputs.length > 0) {
            var isFocused = false;
            formInputs.forEach(function (input) {
                input.addEventListener(
                    "focus",
                    function () {
                        if (!isFocused) {
                            formContainer.classList.add("is-active");
                            isFocused = true;
                        }
                    },
                    { once: true }
                );
            });
        }
    }

    $('input[type="tel"]').on("input", function () {
        this.value = this.value.replace(/[^0-9+()\- ]/g, "");
    });

    // Mobile Card Sliders
    if (window.innerWidth <= breakpoints.lg) {
        document
            .querySelectorAll(".js-mobile-card-slider")
            .forEach(function (element) {
                new Swiper(element, {
                    slidesPerView: 1,
                    loop: false,
                    allowTouchMove: true,
                    freeMode: false,
                    spaceBetween: 20,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                    },
                });
            });
    }
});
